import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { forkJoin } from 'rxjs';
import { CountryCityService } from '../../../../../services/country-city.service';

@Component({
  selector: 'app-countryandcity',
  templateUrl: './countryandcity.component.html',
  styleUrl: './countryandcity.component.scss'
})
export class CountryandcityComponent implements OnInit {

  countryForm!: FormGroup;
  cityForm!: FormGroup;

  contentReady: boolean = false;

  isCountrySubmitting: boolean = false;
  isCitySubmitting: boolean = false;

  activeTab: 'countries' | 'cities' = 'countries';

  countries: any[] = [];
  cities: any[] = [];

  constructor(
    private fb: FormBuilder,
    private countryCityService: CountryCityService
  ) {}

  ngOnInit(): void {
    this.createForms();
    this.getAllData();
  }

  createForms(): void {
    this.countryForm = this.fb.group({
      country_name_en: ['', Validators.required],
      country_name_ar: ['', Validators.required],
    });

    this.cityForm = this.fb.group({
      country_id: ['', Validators.required],
      city_name_en: ['', Validators.required],
      city_name_ar: ['', Validators.required],
    });
  }

  setTab(tab: 'countries' | 'cities'): void {
    this.activeTab = tab;
  }

  getAllData(): void {
    this.contentReady = false;

    forkJoin({
      countries: this.countryCityService.getCountries({ per_page: 1000 }),
      cities: this.countryCityService.getCities({ per_page: 1000 }),
    }).subscribe({
      next: (res: any) => {
        this.countries = this.extractArray(res.countries);
        this.cities = this.extractArray(res.cities);
        this.contentReady = true;
      },
      error: (err: any) => {
        console.log(err);
        this.contentReady = true;
      }
    });
  }

  getCountries(): void {
    this.countryCityService.getCountries({ per_page: 1000 }).subscribe({
      next: (res: any) => {
        this.countries = this.extractArray(res);
      },
      error: (err: any) => {
        console.log(err);
      }
    });
  }

  getCities(): void {
    this.countryCityService.getCities({ per_page: 1000 }).subscribe({
      next: (res: any) => {
        this.cities = this.extractArray(res);
      },
      error: (err: any) => {
        console.log(err);
      }
    });
  }

  addCountry(): void {
    if (this.countryForm.invalid) {
      this.countryForm.markAllAsTouched();
      return;
    }

    this.isCountrySubmitting = true;

    const payload = {
      country_name_en: this.countryForm.value.country_name_en,
      country_name_ar: this.countryForm.value.country_name_ar,
    };

    this.countryCityService.addCountry(payload).subscribe({
      next: () => {
        this.isCountrySubmitting = false;

        this.countryForm.reset({
          country_name_en: '',
          country_name_ar: '',
        });

        this.getCountries();
      },
      error: (err: any) => {
        console.log(err);
        this.isCountrySubmitting = false;
        this.handleError(err, 'حدث خطأ أثناء إضافة الدولة');
      }
    });
  }

  addCity(): void {
    if (this.cityForm.invalid) {
      this.cityForm.markAllAsTouched();
      return;
    }

    this.isCitySubmitting = true;

    const payload = {
      country_id: this.cityForm.value.country_id,
      city_name_en: this.cityForm.value.city_name_en,
      city_name_ar: this.cityForm.value.city_name_ar,
    };

    this.countryCityService.addCity(payload).subscribe({
      next: () => {
        this.isCitySubmitting = false;

        this.cityForm.reset({
          country_id: '',
          city_name_en: '',
          city_name_ar: '',
        });

        this.getCities();
      },
      error: (err: any) => {
        console.log(err);
        this.isCitySubmitting = false;
        this.handleError(err, 'حدث خطأ أثناء إضافة المدينة');
      }
    });
  }

  deleteCountry(id: any): void {
    const confirmDelete = confirm('هل أنت متأكد من حذف هذه الدولة؟');

    if (!confirmDelete) {
      return;
    }

    this.countryCityService.deleteCountry(id).subscribe({
      next: () => {
        this.getAllData();
      },
      error: (err: any) => {
        console.log(err);
        alert('حدث خطأ أثناء حذف الدولة');
      }
    });
  }

  deleteCity(id: any): void {
    const confirmDelete = confirm('هل أنت متأكد من حذف هذه المدينة؟');

    if (!confirmDelete) {
      return;
    }

    this.countryCityService.deleteCity(id).subscribe({
      next: () => {
        this.getCities();
      },
      error: (err: any) => {
        console.log(err);
        alert('حدث خطأ أثناء حذف المدينة');
      }
    });
  }

  getCountryName(countryId: any, countryObj?: any): string {
    if (countryObj) {
      return countryObj.country_name_ar || countryObj.country_name_en || 'غير محدد';
    }

    const country = this.countries.find((item: any) => item.id == countryId);

    return country
      ? country.country_name_ar || country.country_name_en
      : 'غير محدد';
  }

  private extractArray(res: any): any[] {
    if (Array.isArray(res)) {
      return res;
    }

    if (Array.isArray(res?.data?.data)) {
      return res.data.data;
    }

    if (Array.isArray(res?.data)) {
      return res.data;
    }

    return [];
  }

  private handleError(err: any, defaultMessage: string): void {
    if (err?.error?.errors?.country_name_en) {
      alert(err.error.errors.country_name_en[0]);
    } else if (err?.error?.errors?.country_name_ar) {
      alert(err.error.errors.country_name_ar[0]);
    } else if (err?.error?.errors?.city_name_en) {
      alert(err.error.errors.city_name_en[0]);
    } else if (err?.error?.errors?.city_name_ar) {
      alert(err.error.errors.city_name_ar[0]);
    } else if (err?.error?.errors?.country_id) {
      alert(err.error.errors.country_id[0]);
    } else if (err?.error?.message) {
      alert(err.error.message);
    } else {
      alert(defaultMessage);
    }
  }
}